import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { BooksReadByLevelHistoryData } from 'teacher-ui-client/components/giraffe/charts/books-read/by-level/history'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface BooksReadByLevelHistoryResponse {
  books_read_by_level_history: {
    student_id: number
    average_lexile: number
    average_lexile_formatted: string
    '0-300'?: number
    '300-500'?: number
    '500-800'?: number
    '800-2000'?: number
  }[]
}

export async function booksReadByLevelHistory(
  this: StudentEventsService,
  product: LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<BooksReadByLevelHistoryData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('books_read_by_level_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<BooksReadByLevelHistoryResponse>(url, query)
  if (!data) return null

  if (data.books_read_by_level_history.length === 0) return null

  return data.books_read_by_level_history
}
